// 仅在内网构建环境、测试环境 启用vConsole，开发环境和生产构建环境不需要
const VITE_BUILDENV = import.meta.env.VITE_BUILDENV;
import VConsole from 'vconsole';
if (VITE_BUILDENV === 'debug' || VITE_BUILDENV === 'dev' || VITE_BUILDENV === 'test') {
  new VConsole();
}

import { createApp } from 'vue';
import App from './App.vue';
import './style';

import router from './router';
import { createPinia } from 'pinia';

// 常用vant组件全局注册
import components from '@/utils/useComponents';

import PrintTemplate from '@/utils/loadTemplate';

const app = createApp(App);

app.use(router);
app.use(createPinia());

components.forEach(component => app.use(component));

//初始化sentry 必须在app mount之前调用
// initSentry(app, router);

app.component('PrintTemplate', PrintTemplate);

app.mount('#app');
